fx.ns("desktop.common.toolbar", class ToolBarColorPickerButton extends shared.stage.ToolBarButton{
    
    constructor(command, component, container){
        super(command, component, container);

        
    }

    create()
    {
        super.create();

        this.colorPicker = new fx.components.ColorPicker({showOpacity : this.command.opacity, lastColors: this.container.model.customcolors, currentColor : this.component[this.command.field] });
        this.colorPicker.visibleAtStart = false;
        //this.colorPicker.effect = "vslide";
        this.addChild(this.colorPicker, {top : this.realHeight +3, left : 0 /*, width : 310, height:200*/});
    }


    onReady()
    {

        super.onReady();

        //this.on("mousemove", this.onMouseMove, this.container);
        this.on("click", this.onClick, window);

        this.on("selected", this.onSelected, this.colorPicker);

        this.colorIcon = this.find("svg .color");

        this.updateButtonColor( this.component[this.command.field] );        
    }

   
    selectionChanged()
    {
        this.css(this.colorIcon, {fill : this.component[this.command.field] } );  
    }

    destroy()
    {
        super.destroy();
        
        this.colorPicker = null;
    }

    /*onMouseMove(e)
    {
        if (!this.colorPicker || this.colorPicker.animating)
            return;

        let target1 = fx.dom.parent(e.target, ".ToolBarColorPickerButton");
        let target2 = fx.dom.parent(e.target, ".ColorPicker");

        if (target1 && !this.colorPicker.visible && target1 == this.node)
            this.colorPicker.show();
        else
        if ((!target1 || target1 != this.node) && !target2 && this.colorPicker.visible)
            this.colorPicker.hide();
                
    }*/

    onClick(e)
    {
        let list = fx.dom.parent(e.target, ".ColorPicker") 
        let select = fx.dom.parent(e.target, ".ToolBarColorPickerButton") 
        
        if (!(select && select == this.node) && (this.hasClass(e.target, "color") || (list && list == this.colorPicker.node) ) )
            return;

        
        if (select == this.node)
        {
            if (!list)
            {
                if (this.colorPicker.visible)
                {
                    this.removeClass("pushed");
                    this.colorPicker.hide();
                }
                else
                {
                    this.addClass("pushed");
                    this.colorPicker.show();
                    // keep colorPicker in screen bounds
                    let position = fx.dom.offset(this.colorPicker.node);
                    if(position.left+this.colorPicker.realWidth > fx.dom.width(window))
                        this.colorPicker.x -= (position.left+this.colorPicker.realWidth - fx.dom.width(window))+50;
                }
            }
        }
        else
        if (this.colorPicker.visible)
        {
            this.removeClass("pushed");
            this.colorPicker.hide();
        }
    }


    click()
    {
        // disable default click action
    }

    onSelected(event)
    {
        this.action(event.detail);
        
        this.updateButtonColor(event.detail);
    }

    updateButtonColor(color)
    {
        this.css(this.colorIcon, {fill : color} ); 
    }

});